import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/air-api-constant";
import { BehaviorSubject } from "rxjs";
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {

  public favUpdatPromise = new BehaviorSubject<string>("");
  public $favoriteUpdat = this.favUpdatPromise.asObservable();
  ETAThreshold: any;


  constructor(protected http: HttpClient, protected storageService: StorageService) {
  }

  updateFavShipment(shipment: any) {
    this.favUpdatPromise.next(shipment);
  }

  getShipmentsOrder(data: any = {}) {
    //let url = settings.UserEndPoint.AirShipment.SHIPMENT_RESULT;
   // return this.http.post<any>(url, data);
  }

  getFavoriteShipmentsWithDetails(data: any = {}) {
    this.ETAThreshold = this.storageService.getItem('eta_threshold');
    data.lateStatusMinRange = this.ETAThreshold.minLimit,
    data.lateStatusMaxRange = this.ETAThreshold.maxLimit
    data.etaConfigType = this.ETAThreshold.etaConfigType
   // let url = settings.UserEndPoint.Favorite.GET_FAVORITE_WITH_DETAILS;
   // return this.http.post<any>(url, data);
  }

  getFavoriteShipmentsList(data: any = {}) {
    if (!data.shipmentIds) {
      data.shipmentIds = [];
    }
    if (!data.limits) {
      data.limits = -1;
    }
   // let url = settings.UserEndPoint.Favorite.GET_USER_FAVORITE;
   // return this.http.post<any>(url, data);
  }

  setFavoriteShipment(shipmentData: any = {}) {
    if (!shipmentData.comments) {
      shipmentData.comments = '';
    }
    let url = settings.UserEndPoint.Favorite.SET_FAVORITE;
    return this.http.post<any>(url, shipmentData);
  }

  removeFavoriteShipment(shipmentId: string = '') {
    let url = settings.UserEndPoint.Favorite.REMOVE_FAVORITE;
    return this.http.post<any>(url, { shipmentId });
  }

  pinToFavoriteWidget(body: any = {}) {
    let url = settings.UserEndPoint.Favorite.UPDATE_FAVORITE_WIDGET;
    return this.http.post<any>(url, body);
  }
}
